export function isInDevEnvironment(env: string): boolean {
    return env.toUpperCase() === "DEVELOPMENT";
}
